import { __awaiter } from '../node_modules/tslib/tslib.es6.js';

const sendText = (axios, request) => __awaiter(void 0, void 0, void 0, function* () {
    request.phoneNumber = request.phoneNumber.indexOf('+') === 0 ? request.phoneNumber : `+1${request.phoneNumber}`;
    const res = yield axios.post('/waitingList/textLinkToDownloadApp', request);
    return res === null || res === void 0 ? void 0 : res.data;
});
const searchProductsRest = (axios, body, page, facets, cancelToken) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield axios.post('/product/search', { body, page, facets }, {
        cancelToken,
    });
    return res === null || res === void 0 ? void 0 : res.data;
});
const getEntityForLandingPage = ({ axiosEdgeCached, entityId, entityType, }) => __awaiter(void 0, void 0, void 0, function* () {
    return axiosEdgeCached.get(`/cms/landing/${entityType}/${entityId}/entity`);
});
const getRecentlySearchedTerms = (axios, headers) => __awaiter(void 0, void 0, void 0, function* () {
    return axios.get('/recentlyViewed/getSearches', { headers });
});

export { getEntityForLandingPage, getRecentlySearchedTerms, searchProductsRest, sendText };
//# sourceMappingURL=utils.js.map
